import React, { useContext } from 'react';
import styles from './styles.module.scss';
import PageContainer from 'src/components/PageContainer';
import Flex from 'src/components/Flex';
import Button from 'src/components/Button';
import AuthStore from 'src/stores/AuthStore';
import { observer } from 'mobx-react';

function NoActiveOrganizations() {
    const authStore = useContext(AuthStore);

    return (
        <PageContainer>
            <Flex direction="column" align="center" justify="center" className={styles.container}>
                <div className={styles.heading}>No Active Organizations</div>
                <div className={styles.subHeading}>
                    Your account doesn't have any active organization memberships. If you've been invited to an
                    organization, check your email for the invitation link. Otherwise, please contact your administrator
                    for assistance.
                </div>
                <Button
                    onClick={() => authStore.logout()}
                    type="primary"
                    text="Log Out"
                    className={styles.logoutBtn}
                />
            </Flex>
        </PageContainer>
    );
}

export default observer(NoActiveOrganizations);
